import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-swissfelstatus',
  templateUrl: './swissfelstatus.page.html',
  styleUrls: ['./swissfelstatus.page.scss'],
})
export class SwissfelstatusPage {
  // declare variables
  public date: any;
  public status_url = environment.swissfelstatus;
  public assets = environment.assets;
  public refreshIcon = false;

  //constructor
  constructor() { }

  // refreshes the status image
  public doRefresh() {
    this.refreshIcon = true;
    this.date = Date.now();
    setTimeout(() => {
      this.status_url = environment.swissfelstatus + this.date;
      this.refreshIcon = false;
    }, 2000);
  }
}
